import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
declare  let drift;
@Component({
  selector: 'app-site',
  templateUrl: './site.component.html',
  styleUrls: ['./site.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SiteComponent implements OnInit {
  private scrollUp;
  onActivate(e, outlet) {
    outlet.scrollTop = 0;
  }

  constructor(private router: Router, private element: ElementRef) {

    this.scrollUp = this.router.events.subscribe((path) => {
      this.element.nativeElement.scrollIntoView();
    });
  }

  ngOnInit() {
    if (drift) {
      drift.on('ready', (api, payload) => {
        api.widget.show();
        api.openChat();
      });
    }


  }

}



// WEBPACK FOOTER //
// ./src/app/site/site.component.ts